<template>
  <div>
    <topbar
      :titulo="$t('FINANCEIRO.FORNECEDORES')"
      :subtitulo="$t('FINANCEIRO.FORNECEDORES_DESCRICAO_PAGE')"
      :breadcrumbs="breadcrumbs"
    >
      <template #header>
        <div class="d-flex justify-content-between ml-md-4 gap-1">
          <div></div>
          <b-button
            variant="info"
            @click="openModal('fornecedor')"
            v-if="podeCadastrar"
          >
            {{ $t('GERAL.CADASTRAR') }}
          </b-button>
        </div>
      </template>
    </topbar>

    <filtro-fornecedores
      @filtrar="getFiltro"
      @limpar-filtro="getFornecedores"
    />

    <tabela-fornecedores
      :items="items"
      @editar="openModal"
      @alterar-ordenacao="novaOrdenacao"
    />

    <paginacao
      v-model="paginacao"
      :total="paginacao.total"
      @input="getFornecedores"
    />

    <modal-dados-fornecedor
      :exibir="modais.fornecedor"
      :id="modais.fornecedorDados.id"
      @atualiza-tabela="getFornecedores"
      @fechar="closeModal"
    />
  </div>
</template>
<script>
// Utils & Aux:
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import mensagem from '@/common/utils/mensagem';
import modais from '@/common/utils/modais';

// Services:
import EmpresaService from '@/common/services/empresa/empresa.service';

// Components:
import TabelaFornecedores from './components/TabelaFornecedores';
import ModalDadosFornecedor from './components/ModalDadosFornecedor.vue';
import Paginacao from '@/components/paginacao/Paginacao';
import FiltroFornecedores from './components/FiltroFornecedores';

import Topbar from '@/layouts/full-layout/horizontal-sidebar/Topbar.vue';
import Permissoes from '@/components/mixins/permissoes';

export default {
  mixins: [Permissoes],
  components: {
    FiltroFornecedores,
    Topbar,
    TabelaFornecedores,
    ModalDadosFornecedor,
    Paginacao,
  },
  data() {
    return {
      items: [],
      breadcrumbs: [
        { titulo: 'FINANCEIRO.FINANCEIRO' },
        { titulo: 'FINANCEIRO.FORNECEDORES' },
      ],
      filtrandoPor: '',
      paginacao: {
        numeroDaPagina: 1,
        tamanhoDaPagina: 10,
        total: 0,
      },
      modais: {
        fornecedor: false,
        fornecedorDados: {},
      },
      campoOrdenado: null,
      ordem: false,
    };
  },
  mounted() {
    this.getFornecedores();
  },
  methods: {
    // FUNÇÕES OBTENÇÃO DE DADOS:
    getFornecedores(filtro) {
      this.filtrandoPor = filtro === '' ? filtro : this.filtrandoPor;

      this.$store.dispatch(START_LOADING);
      EmpresaService.obterTodosFornecedores(
        this.filtrandoPor,
        this.paginacao,
        this.campoOrdenado,
        this.ordem
      )
        .then(({ data }) => {
          this.items = data.itens;
          this.paginacao.total = data.paginacao.totalDeElementos;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },

    // FUNÇÕES FILTRO
    getFiltro(buscarPor) {
      this.filtrandoPor = buscarPor;
      this.getFornecedores();
    },
    // FUNÇÕES MODAL
    openModal(key, item) {
      return modais.abrirModal(this, key, item);
    },
    closeModal(key) {
      return modais.fecharModal(this, key);
    },
    novaOrdenacao(campoOrdenado, ordem) {
      this.campoOrdenado = campoOrdenado;
      this.ordem = !ordem;
      this.getFornecedores();
    },
  },
};
</script>
